<template>
  <div class="layout-minimal">
    <SiteHeader />
    <slot />
  </div>
</template>
